import { useAsyncData, useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import '~/api/bm4b-pro-scoring/specs'

export function useBmProVisibility({
  featureFlag,
}: {
  featureFlag: keyof ReturnType<typeof useRuntimeConfig>['public']
}) {
  const { public: runtimeConfig } = useRuntimeConfig()
  const { market } = useMarketplace()
  const { user } = useUserStore()
  const $httpFetch = useHttpFetch()

  const isEnabled = (runtimeConfig[featureFlag] as string).includes(
    market.countryCode,
  )

  const { data: proScoring } = useAsyncData(
    'bm4b-pro-scoring-is-professional',
    () => $httpFetch('/api/bm4b-pro-scoring/v1/customers/is-professional'),
    {
      immediate: isEnabled && Boolean(user.value.bmUserId),
      default: () => null,
    },
  )

  const isVisible = computed(
    () => isEnabled && proScoring.value?.is_professional === true,
  )

  return { isVisible }
}
